import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { getAppInstance } from '@helios/auth-firebase-web';

/* ------------------------------------------------------------------ */
/*  Secure playback URL resolution for voice recordings (PRD.271).    */
/*                                                                    */
/*  Recordings are stored at a private, org-scoped Storage path — we   */
/*  intentionally do NOT persist a public URL. Playback resolves an    */
/*  authenticated, token-bearing download URL on demand via the        */
/*  Firebase client SDK (Storage rules enforce org-scoped read).       */
/* ------------------------------------------------------------------ */

/** Resolve an authenticated playback URL from a private storage path. */
export async function resolvePlaybackUrl(storagePath: string): Promise<string> {
  const storage = getStorage(getAppInstance());
  return getDownloadURL(ref(storage, storagePath));
}
